import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import Backend from 'shared/lib/Backend';

const SaveAsTemplate = ({ onClose, save_as_template_url, template_id, caption }) => {
  const [name, setName] = useState('');
  const [error, setError] = useState();
  const [success, setSuccess] = useState();

  const force = error === 'not_uniq';

  const onChange = (event) => {
    setName(event.target.value);
    if(error) setError(null);
  };

  const save = async () => {
    const body = new FormData();
    body.append('name', name);
    if(template_id) body.append('template_id', template_id);
    if(force) body.append('force', force);

    const response = await Backend.post(save_as_template_url, { body });

    switch(response.status) {
      case 'success':
        setSuccess(true);
        break;
      case 'error':
        setError(response.error);
        break;
      case 'redirect':
        window.location = response.url;
        break;
    }
  };
  const disabled = name.trim() ? {} : { disabled: 'disabled' };

  const submitClasses = classNames('btn', { 'btn-success': !force, 'btn-danger': force });

  const renderSuccess = () => {
    setTimeout(onClose, 3000);
    return (
      <div className="save-as-template__notification">
        <i className="fi fi-check" />
        {i18n.t('save_as_template.success')}
      </div>
    );
  };

  const renderDescription = () => {
    if(force) return (
      <div className="save-as-template__alert">
        <div>
          <i className="fa fa-exclamation-triangle"/>
          {i18n.t('save_as_template.not_uniq1')}
          <strong>{name}</strong>
          {i18n.t('save_as_template.not_uniq2')}
        </div>
        {i18n.t('save_as_template.not_uniq3')}
      </div>
    );

    return (
      <div className="save-as-template__description">
        {i18n.t('save_as_template.description')}
      </div>
    );
  };

  if(success) return renderSuccess();

  return (
    <div className="save-as-template__wrapper">
      <div className="save-as-template">
        <div className="save-as-template__header">
          <div className="save-as-template__close" onClick={onClose}>
            <i className="fi fi-close" />
          </div>
          <h3>{caption || i18n.t('save_as_template.caption')}</h3>
        </div>
        <div className="save-as-template__body">
          <input
            type="text"
            className="form-control"
            placeholder={i18n.t('save_as_template.placeholder')}
            value={name}
            onChange={onChange}
          />
          {renderDescription()}
          <div className="save-as-template__actions">
            <button className="btn btn-form" onClick={onClose}>{i18n.t('save_as_template.cancel')}</button>
            <button className={submitClasses} onClick={save} {...disabled}>
              {force ? i18n.t('save_as_template.replace') : i18n.t('save_as_template.save')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveAsTemplate;
